import { render } from "./App.vue?vue&type=template&id=2ae463d9"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2ae463d9&lang=less"

import exportComponent from "D:\\company\\jifen\\AccumulatedPointsStore\\src\\SPA\\AccumulatedPointsStore.ApiEndpoint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__